export default __webpack_public_path__ + "static/media/graduated-blue.796bbf39.svg";